import React, { useEffect, useState } from 'react';
import Errors from '../../../components/errors';
import Loader from '../../../components/loader';
import Form from './form';
import { useClientPriorityQuery } from '../../../services/enumApi';

const ClientContainer = ({ title, clintIsLoading, client, onSave, isLoading, error, readOnly }:any) => {
    
    const [name, setName] = useState('');
    const [priority, setPriority] = useState<number | null>(0);
    const [usePdfImagesInLogViewer, setUsePdfImagesInLogViewer] = useState<boolean>(false);
    const [maximumCuttingsGap, setMaximumCuttingsGap] = useState<number>(20);

    const { data: clientPriorities, isLoading: clientPrioritiesLoading } = useClientPriorityQuery();
    
    const handlePriorityChange = (value: string) => {
        const numValue = value === '' ? null : Number(value);
        setPriority(numValue);
    };
    
    useEffect(() => {
        if (!clintIsLoading && client) {
            setName(client.name);
            setPriority(client.priority);
            setUsePdfImagesInLogViewer(client.usePdfImagesInLogViewer);
            setMaximumCuttingsGap(client.maximumCuttingsGap);
        }
    },[clintIsLoading, client]);

    const onUpdateClient = (e: any) => {
        e.preventDefault();
        onSave({name, priority, usePdfImagesInLogViewer, maximumCuttingsGap});
      };
   
    return (
        <section className="section">
            <div>
                <h1>{title}</h1>
                <Errors error={error}/>
                {(isLoading || clientPrioritiesLoading) && <Loader/>}

                <Form name={name}                      
                    setName={setName}       
                    priority={priority} 
                    setPriority={handlePriorityChange}
                    clientPriorities={clientPriorities}
                    usePdfImagesInLogViewer={usePdfImagesInLogViewer}
                    setUsePdfImagesInLogViewer={setUsePdfImagesInLogViewer}
                    onSave={onUpdateClient}   
                    readOnly={readOnly}
                    maximumCuttingsGap={maximumCuttingsGap}
                    setMaximumCuttingsGap={setMaximumCuttingsGap}
                    />
            </div>
        </section>
    )    
};

export default ClientContainer;